// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#call-container[data-v-41526156]{position:relative;overflow:hidden;padding-bottom:56.25%;max-height:56.25%}\n", ""]);
// Exports
module.exports = exports;
